import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../../../components/Spinner";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { authSelector } from "../../../redux/modules/auth/userSelector";
import { reset } from "../../../redux/modules/auth/slice";
import { login, logout, whoAmI } from "../../../redux/modules/auth/actions";

export default function AdminLogin() {

  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userId, setUserId] = useState("");
  const [error, setError] = useState("");

  const auth = useSelector(authSelector);
  // const user = useSelector(userSelector);

  const { status, message, user, mfaRequired } = auth;

  const handleLogin = () => {
    const userCredentials = {
      user_id: userId,   // ✅ send only user_id for admin
      password,
    };
  
    localStorage.setItem("remember_me", keepSignedIn.toString());
  
    dispatch(login(userCredentials))
      .unwrap()
      .catch((err: any) => {
        console.log("Login error:", err);
        const msg =
          err?.response?.data?.error?.message ||
          err?.error?.message ||
          (Array.isArray(err?.message) ? err.message.join(" ") : err?.message) ||
          "Invalid user_id or password";
  
        setError(msg);
      });
  };
  

  useEffect(() => {
    if (mfaRequired) {
      navigate("/admin/otp");
      return;
    }
  
    if (user) {
      if (user.role === "admin") {
        navigate("/home");   // ✅ keep this
      } else {
        setError("You are Not Authorised to Login to Admin Site");
        dispatch(reset());  // ✅ fine to reset on unauthorized
      }
    }
  }, [user, mfaRequired]);
  
  
  
  


  

  useEffect(() => {
    const token_persist = localStorage.getItem("remember_me");

    if (token_persist === "true") {
      setKeepSignedIn(true);
    } else {
      setKeepSignedIn(false);
    }
  }, []);

  return (
    <>
      {status === "loading" && <Spinner />}

      <div className="sign-up-wrap">
      <h1 className="logo">
          Wendwise
          <sup className="tm">TM</sup>
        </h1>
        <div className="form-container-wrap">
          <form
            className="form-container1"
            onSubmit={(e) => e.preventDefault()}
          >
            <h2>Admin Sign In</h2>
            <div className="form-group">
              {status === "failed" && (
                <p className="text-danger font-weight-bold">{message}</p>
              )}
              <p className="text-danger font-weight-bold">{error}</p>
              <label htmlFor="userid">User Id</label>
              <input
  type="text"
  className="form-control"
  id="userid"
  placeholder="Enter Your User Id"
  required
  value={userId}
  onChange={(e) => setUserId(e.target.value)}
/>

            </div>
            <div className="form-group">
              <label htmlFor="passwd">Password</label>
              <input
                type="password"
                className="form-control"
                id="passwd"
                placeholder="Enter Password"
                // pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                // title="Must contain at least one number, one uppercase, one lowercase letter, one special character and at least 10 characters"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="forgot-link d-flex align-items-center justify-content-between">
              <div className="custom-control custom-checkbox login-check">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="remember"
                  checked={keepSignedIn}
                  onChange={(_) => setKeepSignedIn(!keepSignedIn)}
                />
                <label htmlFor="remember" className="custom-control-label">
                  Keep me signed in
                </label>
              </div>
              {/* <Link to="/password-reset">Forgot Password?</Link> */}
            </div>
            <button
              type="submit"
              className="btn mt-5 btn-block"
              id="btn-submit"
              // onClick={() => navigate("/admin/home")}
              onClick={handleLogin}
            >
              Sign In
            </button>
          </form>
        </div>
        {/* <Spinner /> */}
      </div>
    </>
  );
}
